import {CommonViewController} from './CommonViewController';

/** @ngInject */
export class DetailController extends CommonViewController {
    constructor($scope, userService, arsMainDependencies, restUrl, service ) {

        super($scope, userService, arsMainDependencies);

        this.detailviewDataPromise = null;
        this.restUrl = restUrl;
        this.service = service;
        this.id = this.getId();

        if (this.id) {
            this.loadElement();
        } else {
            this.element = { modifiable: true };
            this.detailviewDataPromise = {};
        }
        this.isProcessing = false;
        this.cancel =(e) => {
            if(e) {
                e.preventDefault();
            }
            this.state.go(this.state.params.listView);
        };
    }

    getId() {
        return this.state.params.id;
    }

    create() {
       return this.detailviewDataPromise = this.service.postUserData(this.restUrl, this.element).then((data) => {
           this.element = data;
           this.isProcessing = false;
           if (data) {
               this.successPop(data ? 'CREATE_SUCCESS' : 'CREATE_ERROR');
           } else {
               this.errorPop('CREATE_ERROR');
           }
       }).catch(() => this.errorPop('CREATE_ERROR'));
    }

    update() {
        return this.detailviewDataPromise = this.service.putUserData(this.restUrl + "/" + this.id, this.element)
            .then(data => this.handleUpdate(data))
            .catch(() => this.errorPop('UPDATE_ERROR'));
    }

    handleUpdate(data) {
        this.element = data;
        this.isProcessing = false;
        if (data) {
            this.successPop('UPDATE_SUCCESS');
        } else {
            this.errorPop('UPDATE_ERROR');
        }
    }

    loadElement() {
        return this.detailviewDataPromise = this.service.getUserData(this.restUrl + "/" + this.id, '')
            .then(data => this.handleLoad(data));
    }

    handleLoad(data) {
        if (data !== null && typeof data !== 'undefined') {
            this.element = data;
        } else {
            this.errorPop('LOAD_ERROR');
        }
    }

    delete(ids) {
        const paramUrl = this.restUrl + (ids ? "/"+ ids : "");
        return  this.detailviewDataPromise = (this.service.deleteUserData) ?
            this.service.deleteUserData(paramUrl, '') :
            this.service.service.delete(paramUrl, '')
            .then((data) => {
                this.isProcessing = false;
                if (data !== null && typeof data !== 'undefined') {
                    this.element = data;
                } else {
                    this.errorPop('DELETE_ERROR');
                }
            });
    }

    deleteElement(stateName, identifier) {
        const nextState = this.state.get(stateName);
        this.state._params = nextState.params;
        this.state._params.service = this.service;
        this.state._params.ids = [this.id];
        this.state._params.names = [this.element[identifier]];
        this.open(nextState);
    }
}
